import { z } from 'zod';
/**
 * Firestore `users/{uid}` profile. Written by the Cloud Functions admin SDK
 * only; clients cannot write (see firestore.rules).
 *
 * `primaryOrgId` + `memberships[]` + `isSuperAdmin` are denormalized
 * mirrors of the custom-claims state, kept in sync by the claim-sync
 * helpers in `apps/functions/src/auth/claims.ts`. `memberships` is a flat
 * list of orgIds the user belongs to (the per-org role lives in the
 * `organizations/{orgId}/members/{uid}` subcollection).
 */
export const UserProfile = z.object({
    uid: z.string(),
    email: z.string().email().nullable(),
    displayName: z.string().nullable(),
    providerId: z.string(),
    emailVerified: z.boolean(),
    /** Active org for the user — clients default `X-Org-Id` to this on bootstrap. */
    primaryOrgId: z.string().nullable().optional(),
    /**
     * Denormalized list of orgIds this user belongs to. Server keeps it in
     * sync on membership changes; cheap read for "my orgs" UI without a
     * collection-group query across every org's members subcollection.
     */
    memberships: z.array(z.string()).default([]),
    /** True iff the user has the platform superAdmin claim. Mirrored here for admin listings. */
    isSuperAdmin: z.boolean().default(false),
});
